module.exports = __webpack_public_path__ + "static/media/ios-appstore.426f0862.svg";